import React from 'react';

// Функция для копирования текста в буфер обмена
const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text)
    .then(() => alert(`Скопировано: ${text}`))
    .catch((err) => console.error("Ошибка копирования: ", err));
};

// Форматировщик дельты (чч мм сс)
const formatDiff = (ms) => {
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return `${h}ч ${m}м ${s}с`;
};

const PopupContent = ({ receipt, getStatusColor, orderNumber, delta }) => {
  return (
    <div>
      {/* Порядковый номер точки в истории */}
      {orderNumber != null && (
        <p>
          <b>№ в истории:</b> {orderNumber}
        </p>
      )}

      <p>
        <b>Квитанция:</b>{' '}
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => copyToClipboard(receipt.receipt_number)}
        >
          {receipt.receipt_number}
        </span>
      </p>

      <p>
        <b>Договор:</b>{' '}
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => copyToClipboard(receipt.contract_number)}
        >
          {receipt.contract_number}
        </span>
      </p>

      <p>
        <b>Клиент:</b> {receipt.client_name}
      </p>

      <p>
        <b>Адрес:</b>{' '}
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => copyToClipboard(receipt.delivery_address)}
        >
          {receipt.delivery_address}
        </span>
      </p>

      <p>
        <b>Статус:</b>{' '}
        <span style={{ color: getStatusColor(receipt.status) }}>
          {receipt.status}
        </span>
      </p>

      {/* Время последнего изменения — только время */}
      <p>
        <b>Изменён:</b>{' '}
        {receipt.status_changed_at
          ? new Date(receipt.status_changed_at).toLocaleTimeString("ru-RU", {
              hour:   "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            })
          : '-'}
      </p>

      {/* Дельта до предыдущего изменения */}
      {delta != null && (
        <p>
          <b>Δ от предыдущего:</b> {formatDiff(delta)}
        </p>
      )}

      {/* Если причина не пустая, выводим её */}
      {receipt.reason && receipt.reason.trim() !== "" && (
        <p>
          <b>Причина:</b> {receipt.reason}
        </p>
      )}

      <div>
        <b>Товары:</b>
        <ul>
          {receipt.products.map((product, index) => {
            const scannedCount = product.marks ? product.marks.length : 0;
            return (
              <li key={index}>
                {product.product_name} x{product.actual_quantity}{' шт. '}
                {product.is_marked && (
                  <span>
                    Скан: {scannedCount}/{product.actual_quantity}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PopupContent;
